export class NovoTiposDiagnose {
  EmpresaId: number;
  Codigo:string = "";
  Descricao:string = "";
  OrdemRelatorioAcompanhamento: number | null;
}
